import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST = 'FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST';
export const FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS = 'FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS';
export const FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE = 'FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE';

const buildCICTemplateUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/cic-template`);
const buildHFv4CICTemplateUrl = (sessionId, language) =>
  buildUrl(`/sessions/${sessionId}/hf-v4-cic-template${language ? `?language=${language}` : ''}`);

export function fetchHFv4CICTemplateIfNeeded(sessionId, language) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildHFv4CICTemplateUrl(sessionId, language) })) {
      return false;
    }

    return dispatch(fetchHFv4CICTemplate(sessionId, language));
  };
}

export function fetchHFv4CICTemplate(sessionId, language) {
  return (dispatch) => {
    const url = buildHFv4CICTemplateUrl(sessionId, language);
    const method = 'GET';

    return dispatch(fetchHFv4CICTemplateRequest()).payload
      .then((response) => dispatch(fetchHFv4CICTemplateSuccess(response)))
      .catch((error) => dispatch(fetchHFv4CICTemplateFailure(error)));

    function fetchHFv4CICTemplateRequest() {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchHFv4CICTemplateSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS,
        payload: response,
        url,
        method,
        sessionId,
      });
    }

    function fetchHFv4CICTemplateFailure(error) {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}

export function fetchCoveredInClassTemplateIfNeeded(sessionId, isDefaultUnchecked) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildCICTemplateUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchCoveredInClassTemplate(sessionId, isDefaultUnchecked));
  };
}

export function fetchCoveredInClassTemplate(sessionId, isDefaultUnchecked) {
  return (dispatch) => {
    const url = buildCICTemplateUrl(sessionId);
    const method = 'GET';

    return dispatch(fetchCICTemplateRequest()).payload
      .then((response) => dispatch(fetchCICTemplateSuccess(response)))
      .catch((error) => dispatch(fetchCICTemplateFailure(error)));

    function fetchCICTemplateRequest() {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchCICTemplateSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_SUCCESS,
        payload: response,
        url,
        method,
        sessionId,
        isDefaultUnchecked,
      });
    }

    function fetchCICTemplateFailure(error) {
      return ApiCall.createAction({
        type: FETCH_COVERED_IN_CLASS_TEMPLATE_FAILURE,
        error,
        url,
        method,
        sessionId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/CoveredInClass/Template/actions.js